module.exports = [{"id":0,"title":"Randy Fromm Monitor Schematics","url":"http://slot-tech.com/amusements/"},{"id":0,"title":"RS components","url":"https://uk.rs-online.com/web/"}]


//////////////////
// WEBPACK FOOTER
// ./src/data-links.json
// module id = 102
// module chunks = 0